
// import React, { useState } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

// export const TextEditor = ({ data, onEditorChange, placeholder, ...props }) => {
//     const [editorData, setEditorData] = useState(data || "");

//     return (
//         <CKEditor
//             editor={ClassicEditor}
//             data={editorData}
//             onChange={(event, editor) => {
//                 const data = editor.getData();
//                 setEditorData(data);

//                 if (onEditorChange) {
//                     onEditorChange(data);
//                 }
//             }}
//             config={{
//                 placeholder: placeholder,
//                 ckfinder: {
//                     // Provide a valid endpoint to handle image uploads
//                     uploadUrl: '/upload/image', // Adjust this URL to your backend endpoint
//                 },
//                 toolbar: [
//                     'heading', '|',
//                     'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
//                     'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|',
//                     'uploadImage', 'blockQuote', 'undo', 'redo'
//                 ],
//                 image: {
//                     toolbar: [
//                         'imageTextAlternative', 'imageStyle:full', 'imageStyle:side'
//                     ],
//                     upload: {
//                         types: ['jpeg', 'jpg', 'png'] // Allow only these file types
//                     }
//                 }
//             }}
//             {...props}
//         />
//     );
// };
import React, { useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const TextEditor = ({ data, onEditorChange, placeholder, ...props }) => {
    const [editorData, setEditorData] = useState(data || "");

    return (
        <CKEditor

            editor={ClassicEditor}
            data={editorData}
            onChange={(event, editor) => {
                const data = editor.getData();
                setEditorData(data);

                if (onEditorChange) {
                    onEditorChange(data);
                }
            }}
            config={{
                placeholder: placeholder,
                extraPlugins: [MyCustomUploadAdapterPlugin],
                toolbar: [
                    'heading', '|',
                    'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
                    'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|',
                    'blockQuote', 'undo', 'redo'
                    // 'uploadImage', 
                ],
                image: {
                    toolbar: [
                        'imageTextAlternative', 'imageStyle:full', 'imageStyle:side'
                    ]
                }
            }}
            {...props}
        />
    );
};

function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new MyUploadAdapter(loader);
    };
}

class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve({ default: reader.result });
                reader.onerror = error => reject(error);
            }));
    }

    abort() { }
}

export default TextEditor;




